import { createContext } from 'react';

const contextInterface = {
  isOtherLines: false,
  setIsOtherLines: () => {},
  beneficiaryNumber: null,
  setBeneficiaryNumber: () => {},
  credit: { creditAvailable: '0', idTransaction: '' },
  setCredit: () => {},
  paymentType: null,
  setPaymentType: () => {},
  actionType: null,
  setActionType: () => {},
  errorCredit: false,
  setErrorCredit: () => {},
  flagOtherLines: false,
  segment: '',
  setSegment: () => {},
};

const OtherLinesContext = createContext(contextInterface);

export default OtherLinesContext;
